import React, { useContext } from "react";

import { RetroLayout } from "components/retrospective/RetroLayout";
import { RetroCard } from "components/retrospective/RetroCard";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { RetroContext } from "components/retrospective/RetrospectiveMain";

const PAGE_DATA = {
  title: "Impacto ambiental",
  subtitle: "Sua descarbonização equivale ao uso diário de ",
  bgGradient: "linear-gradient(135deg, #008236 0%, #007A55 50%, #00786F 100%)",
  illustrationSrc: "/static/img/retro2025/impactImg.png",
  bgImage: "/static/img/retro2025/impact.jpg",
  pageNum: "4",
};

const useStyles = makeStyles()((theme) => ({
  data: {
    flex: 1,
    display: "grid",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    gridTemplateRows: "repeat(3, 1fr)",
    gridTemplateColumns: "repeat(2, 1fr)",

    "& > .MuiTypography-root": {
      gridColumn: "span 2",
    },
  },
}));

export const RetroImpact = () => {
  const { classes } = useStyles();
  const { salasIluminadas, consumoMedioFamiliar, salasClimatizadas } =
    useContext(RetroContext);

  return (
    <RetroLayout {...PAGE_DATA}>
      <Grid item container className={classes.data}>
        <RetroCard
          variant="dark"
          mainInfo={salasIluminadas?.toLocaleString("pt-br") || "-"}
          caption="Salas iluminadas*"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
        <RetroCard
          variant="dark"
          mainInfo={salasClimatizadas?.toLocaleString("pt-br") || "-"}
          caption="Salas climatizadas*"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
        <RetroCard
          variant="dark"
          mainInfo={consumoMedioFamiliar?.toLocaleString("pt-br") || "-"}
          caption="Consumo energético residencial*"
          gridColumnHorizontal="span 2"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 2"
          gridRowVertical="span 1"
        />
        <Typography variant="caption" color="white" align="center">
          *médio das residências no Brasil
        </Typography>
      </Grid>
    </RetroLayout>
  );
};
